module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "chaptitler-a"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Babylon")])]), _vm._v(" "), _c('h3', {
    staticClass: "chaptitle1-a",
    attrs: {
      "id": "ch2-2"
    }
  }, [_vm._v("LAWSUIT OF BUNANITU "), _c('span', {
    staticClass: "size"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("vs")])]), _vm._v(". AKABU-ILU"), _c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter022#rch2fnb",
      "id": "ch2fnb"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("About 550 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C")]), _vm._v(". a record of a lawsuit which raises points of law readily appreciable under our present modern legal system was found. In the case of Bunanitu "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("vs")]), _vm._v(". Akabu-ilu a widow sues her brother-in-law. The widow and her husband, having no children, adopted a young boy. They bought land, paying for it with, in part, the wife’s dowry. On the death of the husband the brother-in-law claimed the estate on the ground that there had been no male heir. The widow maintained that the land belonged to the adopted child and herself. The six-judge court decided in her favor.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bunanitu, daughter of Hariza, comes to the judges of Nabonidus, king of Babylon, and says:")]), _vm._v(" "), _c('p', {
    staticClass: "indent-a"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("[Plaintiff’s Pleading")]), _vm._v(".] “Bin-Addu-natan, son of Nikbata, had me to wife, receiving "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("3")]), _vm._v(" silver mana as dowry, and I bore to him one daughter. I and Bin-Addu-natan, my husband, traded with the money of my dowry, and then with 9⅓ silver mana, including 2½ silver mana borrowed from Iddin-Marduk, we bought 8 rods of land, and a ruined house, in a large estate in Borsippa. We made this purchase jointly, in the fourth year of Nabonidus, king of Babylon. Now my dowry had been in the hands of Bin-Addu-natan, my husband. But I asked for it, and Bin-Addu-natan, in the kindness of his heart, deeded and entrusted to me for future maintenance the 8 rods of land and that house in Borsippa. Then in the fifth year of Nabonidus, king of Babylon, I and Bin-Addunatan, "), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }), _vm._v("my husband, adopted Bin-Addu-amara as our son, and executed a declaration of adoption and provided that the dowry of my daughter Nubta, when she would marry the adopted son, was to be 2 mana 10 shekels of silver and the furniture of a house. Fate then took my husband. On account of this, [his brother], Akabu-ilu, son of my father-in-law, now claims to inherit the house and everything which my husband had deeded and entrusted to me, and also claims the slave Nabu-nur-ili who we had bought by the agent, Nabu-ahi-iddin, for money. I have brought the case to you for judgment.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("[Judgment.]")]), _vm._v(" The Judges heard the parties’ statements, and examined the tablets and documents which Bunanitu produced in court. They held that Akabu-ilu [the brother] had no title to the house in Borsippa, which had been entrusted to [the wife] Bunanitu in place of her dowry; nor to the slave Nabu-nur-ili, whom she and her husband had bought for silver; nor to any property of [his brother] Bin-Addu-natan. [The widow] Bunanitu and the son Bin-Addu-amara, pursuant to the terms of their tablets, are to possess them. Iddin-Marduk is to be repaid the 2½ silver mana which he had loaned as part of the purchase price of that house, and to discharge his claim. Then [the widow] Bunanitu is to be repaid the 3½ mana, her dowry. [The daughter] Nubta, besides her own property, is to have the slave Nabu-nur-ili, according to the agreement of her father.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Judgment entered accordingly.")]), _vm._v(" "), _c('p', {
    staticClass: "note-a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter022#ch2fnb",
      "id": "rch2fnb"
    }
  }, [_vm._v("*")]), _vm._v(" From the translation by H. F. Talbot, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Records of the Past")]), _vm._v(", XI, 101 (London, Samuel Bagster).")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cb35298","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/11_Chapter022.vue
// module id = 99
// module chunks = 0